 <template>
  <div class="whiteOffPersonal">
    <!-- <div class="itemCard">
      <div class="reTime">预约时间<span>{{reData.bookingDate}}&nbsp;{{reData.timeRange}}</span></div>
      <div class="baseLine"></div>
    </div>
    <personalCard v-for="item in personals" :key="item.card">
      <div slot="left" class="leftName">{{item.personName}}</div>
      <div slot="right" class="rightContent" v-if="item.personType == 3">
        <div class="detail">
          <span class="title">年龄</span>
          <span class="name">{{item.age}}</span>
        </div>
        <div class="detail">
          <span class="title">性别</span>
          <span class="name">{{item.gender == 1 ? '男' : '女'}}</span>
        </div>
        <div class="detail" v-if="item.cardNum">
          <span class="title">证件号码</span>
          <span class="name">{{item.cardNum}}</span>
        </div>
      </div>
      <div slot="right" class="rightContent" v-else>
        <div class="detail">
          <span class="title">证件类型</span>
          <span class="name">{{cardTypes.find((c) =>{return c.value == item.cardType}).text}}</span>
        </div>
        <div class="detail">
          <span class="title">证件号码</span>
          <span class="name">{{item.cardNum}}</span>
        </div>
        <div class="detail">
          <span class="title">联系电话</span>
          <span class="name">{{item.phone}}</span>
        </div>
      </div>
    </personalCard>
    <div class="buttonNormal" @click="check">确认核销</div> -->
    <div class="text">请前往窗口或闸机进行验票</div>
  </div>

</template>

<script>
// import personalCard from '../../components/common/personalCard'
export default {
  data() {
    return {
      personals: [],
      reData: {},
      cardTypes: [
        {text: '身份证', value: 1},
        {text: '护照（Passport）', value: 2},
        {text: '台胞证', value: 5},
        {text: '军官证', value: 6},
        {text: '外国人永居证', value: 7},
        {text: '港澳居民来往内地通行证', value: 3}
      ],
      isFid: false
    };
  },

  props: ['team', 'showAddNewGroup'],

  // components: {personalCard},

  methods: {
    getOrderDetail(id) {
      this.$ajax(`/api/ticket/front/order/detail-encrypt?encryptInfo=${id}`).then((res) => {
        this.personals = res.data.peoples
        this.reData = res.data.ticketOrder
        this.reData.timeRange = res.data.ticketOrder.timeRange.replace(':00-', '-').substring(0,11)
      })
    },

    check() {
      this.$ajax.put(`/api/ticket/front/order/write-off?encryptInfo=${this.$route.query.encryptInfo}`).then((res) => {
        alert('核销成功')
      })
    }
  },

  created() {
    this.isFid = !isNaN(Number(this.$route.query.museumCode)) ? true : false
    this.getOrderDetail(this.$route.query.encryptInfo)
    this.$store.state.museumCode = this.$route.query.museumCode
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .whiteOffPersonal{
    .reTime{
      font-size: 0.5rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      span{
        font-size: 0.42rem;
        font-weight: normal;
        margin-left: 0.7rem;
      }
    }
    .text{
      margin: 0.5rem;
      margin-top: 2rem;
      font-size: 0.6rem;
      text-align: center;
    }
  }
</style>
